// extracted by mini-css-extract-plugin
export var heroImage = "_ld-1";
export var modal = "_ld-0";